/* global axios */
import ApiClient from '../ApiClient';

class StudioAnalytics extends ApiClient {
  constructor() {
    super('ai/sessions', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  byModel(params = {}) {
    return axios.get(`${this.url}/by_model`, { params });
  }

  byAgent(params = {}) {
    return axios.get(`${this.url}/by_agent`, { params });
  }

  overTime(params = {}) {
    return axios.get(`${this.url}/over_time`, { params });
  }

  byChannel(params = {}) {
    return axios.get(`${this.url}/by_channel`, { params });
  }

  byTermination(params = {}) {
    return axios.get(`${this.url}/by_termination`, { params });
  }

  // Feed unificado de avaliações (CSAT ∪ tickets ∪ chamados) — vive em
  // ai/satisfaction, irmão do ai/sessions.
  satisfactionFeed(params = {}) {
    return axios.get(`${this.url.replace('/sessions', '/satisfaction')}/feed`, {
      params,
    });
  }

  // Grupos por agente com as contagens vindas do BANCO (período inteiro).
  // Pagina GRUPOS; as linhas de cada balde vêm do satisfactionFeed filtrado.
  satisfactionGroups(params = {}) {
    return axios.get(
      `${this.url.replace('/sessions', '/satisfaction')}/groups`,
      { params }
    );
  }

  satisfactionOverTime(params = {}) {
    return axios.get(
      `${this.url.replace('/sessions', '/satisfaction')}/over_time`,
      { params }
    );
  }
}

export default new StudioAnalytics();
